import { Route, Routes, useParams } from 'react-router-dom';

import useIntegration from 'api/useIntegration';

import BundlesTable from './BundlesTable';
import { OffersForm } from './Form/OffersForm';

import '../../views/view.scss';

const BundlesView = () => {
  const { publisherId } = useParams();
  const { data } = useIntegration(publisherId).getIntegration;
  return (
    <Routes>
      <Route path="/" element={<BundlesTable />} />
      <Route
        path="/form"
        element={<OffersForm isPlayerInfoSync={!!data?.playerInfoSyncUrl} />}
      />
      <Route
        path="/form/:offerId"
        element={
          <OffersForm
            edit={true}
            isPlayerInfoSync={!!data?.playerInfoSyncUrl}
          />
        }
      />
      <Route
        path="/dup/:offerId"
        element={
          <OffersForm dup={true} isPlayerInfoSync={!!data?.playerInfoSyncUrl} />
        }
      />
    </Routes>
  );
};

export default BundlesView;
